(function($, undefined) {

	'use strict';
    var eventsAutocomplete;
    var eventsChoiceRemove;

	var initPageHeaderEventSlider = function() {
		$('.page-header-event-outer').each(function() {
			var com = $(this);
            if (!(com.hasClass('ver3') || com.hasClass('ver4'))) {
                return;
            }
            
			var textSlider = com.find('.page-header-event-content-top');
			var imagesSlider = com.find('.page-header-event-images-ctn');
            var boxesSlider = com.find('.page-header-event-boxes-ctn');
            var delay = com.find('.page-header-event-inner').attr('data-delay');

            if (com.hasClass('admin')) {
                textSlider.slick({
                    dots: false,
                    arrows: true,
                    autoplay: false,
                    prevArrow: com.find('.arrow-btn.prev'),
                    nextArrow: com.find('.arrow-btn.next'),
                    slide: '.page-header-event-text-ctn',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-boxes-ctn')
                });
                textSlider.find('.page-header-event-text-ctn').fadeIn();

                imagesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: false,
                    slide: '.page-header-event-image',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-content-top, .page-header-event-boxes-ctn'),
                    fade: true
                });
                imagesSlider.find('.page-header-event-image').fadeIn();

                boxesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: false,
                    slide: '.page-header-event-box-ctn',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-content-top')
                });
                boxesSlider.find('.page-header-event-image').fadeIn();

                $('*[draggable!=true]','.slick-track').unbind('dragstart');
                $('.page-header-event-box').draggable();

                $(".page-header-event-box").on("dragstop",function(event, ui){
                    var boxX = ui.position.left;
                    var boxY = ui.position.top;

                    var langs = $('html').attr('data-all-langs');

                    updateLabelLangs(ui.helper.attr("data-name")+'-x', boxX, langs, function() {}, true);
                    updateLabelLangs(ui.helper.attr("data-name")+'-y', boxY, langs, function() {}, true);
                });


            }
            else {
                textSlider.slick({
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: delay*1000,
                    prevArrow: com.find('.arrow-btn.prev'),
                    nextArrow: com.find('.arrow-btn.next'),
                    slide: '.page-header-event-text-ctn',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-boxes-ctn')
                    // asNavFor: (imagesSlider, boxesSlider)
                });
                textSlider.find('.page-header-event-text-ctn').fadeIn();

                imagesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: delay*1000,
                    slide: '.page-header-event-image',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-content-top, .page-header-event-boxes-ctn'),
                    fade: true
                    // asNavFor: (textSlider, boxesSlider),
                });
                imagesSlider.find('.page-header-event-image').fadeIn();

                boxesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: delay*1000,
                    slide: '.page-header-event-box-ctn',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-content-top')
                    // asNavFor: (textSlider, imagesSlider)
                });
                boxesSlider.find('.page-header-event-image').fadeIn();
            }
		});
	};

    var fetchEvents = function(){
        var t = $(this);
        var parent = t.closest(".events-autocomplete-results");
        var dropdown = parent.find(".events-results-ctn");
        var input = parent.find(".events-autocomplete-results-choice");
        var val = t.val();
        
        var arr = input.val().split(",");
        if(val.length > 2){
            ajax("/action/pmiEvent?getFutureEvents=true&q=" + encodeURIComponent(val), function (response, e) {
                dropdown.empty();
                var json = JSON.parse(response.trim());
                $.each(json, function (k, v) {
                    var cl = "";
                    if(arr.indexOf(String(json[k].id)) !== -1){
                        cl = " pmi-autocomplete-event-name-added";
                    }
                    var el = $("<div class='pmi-autocomplete-event-name" + cl + "' data-id='" + json[k].id + "'></div>").text(json[k].name);
                    dropdown.append(el);
                });
                dropdown.slideDown();
                dropdown.find(".pmi-autocomplete-event-name:not('.pmi-autocomplete-event-name-added')").on("click", selectEvent);
            }, true);
        }
    };
    
    var selectEvent = function(){
        var t = $(this);
        var id = t.attr("data-id");
        
        var name = t.text();
        var parent = t.closest(".events-autocomplete-results");
        var tags = parent.find(".events-results-tag-ctn");
        var input = parent.find(".events-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) === -1) {
            arr.push(id);
            var el = $("<div class='pmi-autocomplete-event-name-tags' data-id='" + id + "'></div>");
            var el2 = "<span class='pmi-remove-tag'>X</span>";
            var el3 = "<span>" + name + "</span>";
            el.append(el3);
            el.append(el2);
            el.on("click", removeSelectedEvents);
            tags.append(el);
            t.addClass("pmi-autocomplete-event-name-added");
            if (tags.not(":visible")) {
                tags.slideDown();
            }
        }

        input.val(arr.join(","));
		var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function() {
			if (t.hasClass('refresh')) {
				window.location.reload();
			}
		}, true);
    };
    
    function removeSelectedEvents(){
        var t = $(this);
        var id = t.attr("data-id");
        var parent = t.closest(".events-autocomplete-results");
        var tags = parent.find(".events-results-tag-ctn");
        var input = parent.find(".events-autocomplete-results-choice");
        
        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) !== - 1) {
            arr.splice(arr.indexOf(id), 1);
            if(arr.length === 1){                
                tags.slideUp();
            }
        }
        input.val(arr.join(","));
        t.remove();
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    }

	var init = function() {
		initPageHeaderEventSlider();
        
        eventsAutocomplete = $(".event-featured-pick");
        eventsAutocomplete.on("keyup", fetchEvents);
        eventsAutocomplete.on("focus", fetchEvents);
        
        eventsChoiceRemove = $(".pmi-autocomplete-event-name-tags");
        eventsChoiceRemove.on("click", removeSelectedEvents);
        
        $(document).on('click', function (event) {
            if (!$(event.target).closest('.events-autocomplete-results').length) {
                $(".events-results-ctn").slideUp();
            }
        });
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

